'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = require('jss-theme-reactor');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('ActivityListItemAvatar', function (theme) {
  return {
    root: {
      alignItems: 'center',
      alignSelf: 'center',
      display: 'flex',
      fontSize: theme.typography.rhythmByUnit(3.5),
      height: theme.typography.rhythmByUnit(4)
    }
  };
});

var ActivityListItemAvatar = (_temp = _class = function (_React$Component) {
  _inherits(ActivityListItemAvatar, _React$Component);

  function ActivityListItemAvatar() {
    _classCallCheck(this, ActivityListItemAvatar);

    return _possibleConstructorReturn(this, (ActivityListItemAvatar.__proto__ || Object.getPrototypeOf(ActivityListItemAvatar)).apply(this, arguments));
  }

  _createClass(ActivityListItemAvatar, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            classNameProp = _props.className,
            Component = _props.component,
            props = _objectWithoutProperties(_props, ['className', 'component']);

        var classes = this.context.styleManager.render(styleSheet);
        var className = (0, _classnames2['default'])(classes.root, classNameProp);

        return _react2['default'].createElement(Component, Object.assign({}, props, { className: className }));
      }

      return render;
    }()
  }]);

  return ActivityListItemAvatar;
}(_react2['default'].Component), _class.displayName = 'ActivityListItemAvatar', _class.defaultProps = {
  component: 'div'
}, _class.contextTypes = {
  styleManager: _propTypes2['default'].object.isRequired
}, _temp);
exports['default'] = ActivityListItemAvatar;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/List/ActivityListItemAvatar.js
// module id = 739
// module chunks = 32